export const STORAGE_AUTH_KEY = 'auth';
